import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
class PromoSlider extends Component {
	
	render() {
		const { slides } = this.props;
		// console.log(slides);
		return (
			<React.Fragment>

				<section className="">
				<div className="banner-section">
					<OwlCarousel
						className="owl-theme"
						nav={true}
						autoplay
						loop={false}
						dots={true}
						items={1} 
						rewind={true}          
						>
						{slides.length === 0 ? (
							<ContentLoader
								height={170}
								width={400}
								speed={1.2}
								primaryColor="#f3f3f3"
								secondaryColor="#ecebeb"
							>
								<rect x="20" y="0" rx="4" ry="4" width="168" height="168" />
								
							</ContentLoader>
						) : (
						
						slides.map(slide =>
								
								<div className="slide-item" key={slide.slide_id}>
									<img
										src={slide.slider_image}
										alt={slide.slider_text}
										className={`slider-wrapper__img slider-cust-img `}											
									/>
										
								</div>

								
						))}
					</OwlCarousel>	
				</div>
				</section>

				
			</React.Fragment>
		);
	}
}

export default PromoSlider;
